Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.HistoryScreen = (function () {

    function DataImportHistoryScreen() {

        this.className = 'historyScreen';

        this.rootEl = document.createElement("div");
        this.rootEl.className = "historyScreen";
        this.filterTimeEl = document.createElement("div");
        this.filterTimeEl.className = "historyScreenTimeFilter";
        this.listEl = document.createElement("div");
        this.listEl.className = "historyScreenList";
        this.search = document.createElement("input");
        this.filterHistory = {
            pageSize: 50,
            pageNum: 0,
            namespace: null,
            status: ["COMPLETED", "FAILED", "CANCELED"],
            period: "TODAY",
            search: null
        };
        this.paginateTimeout = null;
        this.searchTimeout = null;
        this.waitingPaginate = false;
        this.paginate = () => {
            if (!this.waitingPaginate) {
                this.waitingPaginate = true;
                this.filterHistory.pageNum += 1;
                this.getHistory(function (data) {
                    this.waitingPaginate = false;
                    this.renderList(data);
                }.bind(this));
            }
        };

        this.filterByTime = function (name) {
            this.filterHistory.pageNum = 0;
            this.filterHistory.period = name.toUpperCase();
            this.getHistory(function (data) {
                this.renderList(data, true);
            }.bind(this));
        };

        this.clickTimeFilter = function (el, name) {
            var selected = document.querySelector(".historyScreenTimeFilterItem.selected");
            if (selected) {
                selected.className = selected.className.replace("selected", '').trim();
            }
            el.className += " selected";
            this.filterByTime(name);
        };

        this.renderTimeFilterItem = function (name) {
            var el = document.createElement("div");
            el.className = "historyScreenTimeFilterItem";
            el.addEventListener("click", function () {
                this.clickTimeFilter(el, name);
            }.bind(this));
            el.appendChild(document.createTextNode(Monet.I18n.getResourcesByKey(name)));
            this.filterTimeEl.appendChild(el);
        };

        this.renderTimeFilter = function () {
            ["today", "week", "month"].forEach(this.renderTimeFilterItem.bind(this));
            this.clickTimeFilter(this.filterTimeEl.childNodes[0], "today");
        };

        this.addScrollListener = event => {
          const scrollArea = event.target;
          const delta = scrollArea.scrollHeight
            - scrollArea.scrollTop
            - scrollArea.getBoundingClientRect().height;

          if (Math.floor(delta) <= 0) {
            clearTimeout(this.paginateTimeout);
            this.paginateTimeout = setTimeout(this.paginate, 350);
          }
        }

        this.renderList = (data, clearList) => {
            const fragment = document.createDocumentFragment();
            const renderLinkToDownloadErrorLog = (item) => {
                const downloadElement = document.createElement('span');
                downloadElement.onclick = (event) => {
                    event.stopPropagation();
                    const url = `/Process/${item.processId}/DownloadErrors`;
                    Monet.Ajax.downloadCSV(item.fileName, url, 'get');
                };
                downloadElement.innerHTML = `${Monet.I18n.getResourcesByKey('Greenmile.DataImport.downloadErrorLog')}`;
                return downloadElement;
            };

            const renderTemplateLayout = (item) => {
              const templateElement = document.createElement('span');
              templateElement.className = 'historyItemTemplate';
              templateElement.innerHTML = `${Monet.I18n.getResourcesByKey('greenmile.dataimport.layoutname')} ${item.fileLayoutName}`;
              return templateElement;
            }

            const renderLinkToDownloadImportedFile = (item) => {
                const downloadLogFile = document.createElement('span')
                downloadLogFile.onclick = (event) => {
                    event.stopPropagation()
                    const url = `/TextFileUpload/Download/${item.processId}`
                    Monet.Ajax.downloadCSV(item.fileName, url, 'get')
                }
                downloadLogFile.innerHTML = `${Monet.I18n.getResourcesByKey('Greenmile.DataImport.csv.download')}`
                return downloadLogFile
            }

            const renderImportLogList = (item) => {
                const element = document.createElement('div');
                const importInfo = document.createElement('div');
                const containerDownloadButtons = document.createElement('div');
                const message = document.createElement('span');
                const title = document.createElement('span');
                const createdDate = document.createElement('span');
                const typeImport = document.createElement('span');
                const icon = document.createElement('i');
                const locale = Monet.Session.User.preferedLocale;
                const hasErrors = !item.processStatus || item.processStatus !== 'COMPLETED' || item.errors;
                const messageText = (hasErrors ? 'Greenmile.DataImport.importError' : 'Greenmile.DataImport.importSucess');
                const dateFormat = `${locale.dateFormat.toUpperCase()} ${locale.timeFormat}`;
                const importTypeResource = Greenmile.DataImport.Utils.getImportTypeDomainsByType(Greenmile.DataImport.Utils.getImportTypeDomains(), item.importType);

                icon.className = `gmfont icon-file-${(hasErrors) ? 'fail' : 'success'}`;
                importInfo.className = 'historyScreenInformation';
                title.className = 'historyScreenListItemFileName';
                title.innerHTML = item.fileName;
                createdDate.className = 'historyScreenListItemCreatedDate';
                createdDate.innerHTML = moment(item.createdDate).format(dateFormat);
                if (importTypeResource && importTypeResource.length > 0) {
                    const typeImportResource = Monet.I18n.getResourcesByKey('Greenmile.DataImport.TypeImport');
                    const importTypeResourceDesc = Monet.I18n.getResourcesByKey(importTypeResource[0].description);
                    const typeImportText = document.createTextNode(`${typeImportResource}: ${importTypeResourceDesc}`);
                    typeImport.appendChild(typeImportText);
                }
                message.className = 'historyScreenListItemMessage';
                message.innerHTML = Monet.I18n.getResourcesByKey(messageText);

                containerDownloadButtons.className = 'historyScreenDownloadList';

                if (hasErrors) containerDownloadButtons.appendChild(renderLinkToDownloadErrorLog(item));

                containerDownloadButtons.appendChild(renderLinkToDownloadImportedFile(item));
                containerDownloadButtons.appendChild(renderTemplateLayout(item));

                importInfo.appendChild(title);
                importInfo.appendChild(message);
                importInfo.appendChild(createdDate);
                importInfo.appendChild(typeImport);
                importInfo.appendChild(containerDownloadButtons);
                element.className = 'historyScreenListItem';
                element.appendChild(icon);
                element.appendChild(importInfo);

                element.addEventListener('click', () => {
                    window.location.href = `#/DataImport/SeeLogs/${item.processId}/${encodeURI(item.fileName.replace(/^\/*/, ''))}`;
                });
                return element;
            };

            if (data && data.length) {
                data.forEach((item) => {
                    fragment.appendChild(renderImportLogList(item));
                });
            } else if (clearList) {
                const noProcess = document.createElement('div');
                noProcess.className = 'no-process';
                noProcess.innerHTML = Monet.I18n.getResourcesByKey('DataImporter.history.noProcess');
                fragment.appendChild(noProcess);
            }
            if (clearList) {
                this.listEl.innerHTML = '';
            }
            this.listEl.appendChild(fragment);
        };

        this.getHistory = function (callback) {
            var ajax = new Monet.Ajax();
            ajax.url = "Process/Progresses";
            ajax.method = "POST";
            ajax.data = this.filterHistory;
            ajax.success = callback || this.renderList.bind(this);
            ajax.send();
        };

        this.filterBySearch = function () {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(function () {
                this.filterHistory.pageNum = 0;
                this.filterHistory.search = this.search.value;
                this.getHistory(function (data) {
                    this.renderList(data, true);
                }.bind(this));
            }.bind(this), 250);
        };

        this.textSearch = function () {
            this.search.type = "search";
            this.search.className = "historyScreenSearch";
            this.search.setAttribute("placeholder", Monet.I18n.getResourcesByKey("textfile.history.search"));
            this.search.addEventListener("keydown", this.filterBySearch.bind(this));
            return this.search;
        };

        this.render = function () {
            var title = document.createElement("div"),
                entity = new Greenmile.DataImport.EntityList(),
                entitySearchContainer = document.createElement("div"),
                separator = document.createElement("div");

            entity.removeEmpty = false;
            entity.onChange = (function (self) {
                return function () {
                    self.filterHistory.pageNum = 0;
                    var value = this.entityPicklist.getValue();
                    if (value === "") {
                        self.filterHistory.namespace = null;
                    } else {
                        self.filterHistory.namespace = value;
                    }
                    self.getHistory(function (data) {
                        self.renderList(data, true);
                    });
                };
            }(this));

            title.className = "historyScreenTitle";
            entitySearchContainer.className = "entityInputContainer";
            separator.className = "separator";

            title.appendChild(document.createTextNode(Monet.I18n.getResourcesByKey("dataImport.historyScreen.title")));
            this.renderTimeFilter();
            this.rootEl.appendChild(title);
            this.rootEl.appendChild(this.filterTimeEl);

            entitySearchContainer.appendChild(entity.render());
            entitySearchContainer.appendChild(separator);
            entitySearchContainer.appendChild(this.textSearch());
            this.rootEl.appendChild(entitySearchContainer);
            this.rootEl.appendChild(this.listEl);
        };

        this.clear = function() {
          this.rootEl.innerHTML = '';
          this.filterTimeEl.innerHTML = '';
          this.listEl.innerHTML = '';
        };

        this.show = function () {
            var container = document.querySelector('.form_DataImport');
            container.innerHTML = '';
            container.parentNode.setAttribute('screen', this.className);
            this.render();
            container.removeEventListener('scroll', this.addScrollListener);
            container.addEventListener('scroll', this.addScrollListener);
            container.appendChild(this.rootEl);
        };

    }

    return DataImportHistoryScreen;

})();
